const TOPICS = [
  { tag: '热门连载', count: '1.2万讨论', hot: true },
  { tag: '新作推荐', count: '8.5千讨论', hot: true },
  { tag: '完结精选', count: '6.3千讨论', hot: false },
  { tag: '独家汉化', count: '9.1千讨论', hot: true },
  { tag: '漫评热议', count: '5.8千讨论', hot: false },
  { tag: '周更速递', count: '7.2千讨论', hot: true },
  { tag: '经典回顾', count: '4.6千讨论', hot: false },
  { tag: '作者专栏', count: '3.9千讨论', hot: false },
  { tag: '读者社区', count: '6.7千讨论', hot: true },
];

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-8">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <a
              key={topic.tag}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer border ${
                topic.hot
                  ? 'bg-primary-100/70 text-primary-700 border-primary-200 hover:bg-primary-200/70'
                  : 'bg-background-100 text-foreground-600 border-background-200 hover:bg-background-200/70'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
              <span>#{topic.tag}</span>
              <span className="text-xs opacity-70">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}